import * as React from "react";
import type { SVGProps } from "react";
const SvgIconHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 21 21"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      id="Vector"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.22.02c-.16.04-.24.08-.4.21L.69 8.63c-.36.38-.6.88-.65 1.4-.04.31-.04 8.33 0 8.62q.11.88.75 1.5.59.54 1.4.65c.29.03 16.19.03 16.47 0 .3-.04.53-.11.8-.24.76-.37 1.25-1.07 1.36-1.92.03-.29.03-8.31 0-8.6q-.06-.45-.26-.84c-.14-.27-.26-.44-.53-.7-.39-.38-9.04-8.3-9.15-8.37-.17-.12-.43-.16-.65-.1M6.28 5.81l-4.3 3.96q-.18.17-.21.29c-.04.1-.04.48-.04 4.32l.01 4.2.07.12q.11.22.33.33l.1.05H18.6l.1-.05q.22-.11.33-.33l.07-.12v-4.2c.01-3.84.01-4.21-.02-4.32q-.04-.12-.21-.3c-.19-.18-8.42-7.73-8.44-7.73zm-1.33 5.34q-.43.08-.66.5c-.05.1-.05.14-.05.35 0 .22.01.26.1.5.36.98.8 1.68 1.46 2.37q1.57 1.62 3.87 1.92c.3.04 1.2.04 1.5 0q2.3-.3 3.85-1.91c.69-.71 1.13-1.42 1.48-2.39.09-.25.1-.3.1-.5 0-.27-.05-.38-.22-.58-.38-.41-1.1-.33-1.36.16l-.15.36c-.4 1.17-1.23 2.12-2.33 2.68-.69.35-1.32.5-2.12.5s-1.44-.15-2.13-.5c-1.1-.56-1.93-1.51-2.33-2.67-.1-.32-.19-.46-.31-.58q-.3-.26-.7-.2"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconHome;
